
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#141B34","stroke-width":"1.25","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M9.333 5.333H6.667c-1.655 0-2 .346-2 2v7.334h6.666V7.333c0-1.654-.345-2-2-2z"}}),_c('path',{attrs:{"d":"M7.333 8h1.334m-1.334 2h1.334m-1.334 2h1.334M14 14.667v-9.21c0-.819 0-1.228-.2-1.557-.198-.33-.557-.512-1.274-.879L9.632 1.544c-.774-.395-.965-.256-.965.608v2.984M2 14.667v-6C2 8.115 2.115 8 2.667 8h2M14.667 14.667H1.333","stroke-linecap":"round"}})])])
          )
        }
      }
    